module.exports = __webpack_public_path__ + "img/cert17.73fb4676.png";